import ButtonTooltip from "components/Common/ButtonTooltip";
import QuotationCustomerForm from "pages/QuotationPages/Quotation/Customer/QuotationCustomerForm";
import { useState } from "react";

const ProfileEdit = ({ data, onCustomer }) => {
  const [modal, setModal] = useState(false)
  const toggleModal = () => setModal(prev => !prev)
  
  return (
    <div className="mt-2">
      <ButtonTooltip
        type="edit"
        onClick={() => toggleModal()}
        btnId={`customer-profile`}
        btnName="Edit Profile"
      />
      <QuotationCustomerForm
        isOpen={modal}
        initialData={data}
        onCustomer={onCustomer}
        toggle={toggleModal}
        title={`${data?.id ? "Edit New Customer" : "Add New Customer"}`}
        submitText={`${data?.id ? "Edit Customer" : "Add Customer"}`}
      />
    </div>
  )
}

export default ProfileEdit
